import { Empty } from '@digibee/beehive-ui';

import EnvironmentDeployedVersion from './components/EnvironmentDeployedVersion';
import HistoryTable from './components/HistoryTable/HistoryTable';

import i18n from '~/common/helpers/i18n';
import theme from '~/common/styled/theme';

const PipelineHistoryBeta = ({
  deployPipelineIds,
  deployPipelineById,
  deployPipelineLoading,
  pipelineIds,
  pipelineById,
  pipelinesLoading,
  updatePipelineVersionMinor,
  isUpdatingVersion,
  goToPipeline,
  archive,
  remove,
  next,
  totalPages,
  getLatest,
  getDeployment,
  errorFind,
  totalElements
}) => (
  <>
    <EnvironmentDeployedVersion
      deployPipelineIds={deployPipelineIds}
      deployPipelineById={deployPipelineById}
      loading={deployPipelineLoading}
    />
    {errorFind && (
      <Empty
        illustration={theme.images.pictureError}
        title={i18n.t('scenes.consumers.messages.error.error_generic_prompt')}
        message={i18n.t('scenes.consumers.guidance.error_generic_msg')}
        buttonText={i18n.t('verb.update')}
        /* eslint-disable no-restricted-globals */
        buttonClick={() => location.reload()}
      />
    )}
    {!errorFind && (
      <HistoryTable
        pipelineIds={pipelineIds}
        pipelineById={pipelineById}
        loading={pipelinesLoading}
        isUpdatingVersion={isUpdatingVersion}
        goToPipeline={goToPipeline}
        deployPipelineIds={deployPipelineIds}
        deployPipelineById={deployPipelineById}
        archive={archive}
        remove={remove}
        updatePipelineVersionMinor={updatePipelineVersionMinor}
        next={next}
        totalPages={totalPages}
        getLatest={getLatest}
        getDeployment={getDeployment}
        totalElements={totalElements}
      />
    )}
  </>
);

export default PipelineHistoryBeta;
